import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class StarRatingComponent implements OnInit {
  @Input() rating: number = 0;
  @Input() hasSvg: boolean = false;

  get stars(): any[] {
    return new Array(Math.min(this.rating, 5));
  }

  get rest(): any[] {
    return new Array(5 - Math.min(this.rating, 5));
  }

  constructor() {}

  ngOnInit(): void {}
}
